export const BOM_POSITION_ID = "bomPositionId";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const USER_IDS = "userIds";
export const COMMUNITY_ID = "communityId";
export const STATUS = "status";
export const BOM_USER_ID = "bomUserId";
export const USER_ID = "userId";

export const statusOptions = [
  { label: "Active", value: "active" },
  { label: "Inactive", value: "inactive" },
];
